import { Box, Dialog } from '@mui/material'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import generateCloudinaryLink from 'src/_utils/generateCloudinaryLink'

export default function OrderShipmentImage({ image }) {
    const { t } = useTranslation()
    const [openImage, setOpenImage] = useState(false)

    return (
        <>
            <Dialog maxWidth="lg" fullWidth onClose={() => setOpenImage(false)} open={openImage}>
                <img src={generateCloudinaryLink(image)} style={{ objectFit: 'contain' }} alt={`upload`} />
            </Dialog>
            <Box
                component="img"
                onClick={() => setOpenImage(true)}
                sx={{
                    maxHeight: 250,
                    width:"100%",
                    objectFit: "cover",
                    cursor: 'pointer',
                }}
                alt={t("Attachment")}
                src={generateCloudinaryLink(image)}
            />
        </>
    )
}
